import { gql, useApolloClient } from '@apollo/client';
import {
  ArticleFormat,
  GetSuggestedTagsListQuery,
  GetSuggestedTagsListQueryVariables,
} from '../../__generated__/queries-web';

const GET_SUGGESTED_TAGS_QUERY = gql`
  query GetSuggestedTagsList(
    $article: ArticleLikeInput!
    $where: ArticleTagsTagFilterSearchInput
  ) {
    suggestTags(article: $article, where: $where) {
      id
      title
      type
      relationId
      articleUsages {
        total
        brandKey
      }
      brandedContents {
        isActive
        brandKey
      }
    }
  }
`;

const getQueryBody = ({
  article,
  where,
}: GetSuggestedTagsListQueryVariables) => ({
  query: GET_SUGGESTED_TAGS_QUERY,
  variables: {
    article,
    where,
  },
});

const getArticleVideoQueryBody = ({
  article,
  where,
}: GetSuggestedTagsListQueryVariables) => ({
  query: GET_SUGGESTED_TAGS_QUERY,
  variables: {
    article: {
      title: article.title,
    },
    where,
  },
});

interface SearchSuggestedTagsParams {
  article: GetSuggestedTagsListQueryVariables['article'];
  where?: GetSuggestedTagsListQueryVariables['where'];
}

export const useSearchSuggestedTagsGetterPromise = () => {
  const client = useApolloClient();

  return ({ article, where }: SearchSuggestedTagsParams) =>
    client.query<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>(
      getQueryBody({ article, where }),
    );
};

export const useSearchSuggestedTagsGetter = () => {
  const client = useApolloClient();

  return ({ article, where }: GetSuggestedTagsListQueryVariables) => {
    return client
      .query<GetSuggestedTagsListQuery, GetSuggestedTagsListQueryVariables>(
        article?.format === ArticleFormat.Video
          ? getArticleVideoQueryBody({ article, where })
          : getQueryBody({ article, where }),
      )
      .then(({ data, errors }) => {
        if (errors?.length) {
          throw errors[0];
        }

        return data?.suggestTags;
      });
  };
};
